import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("axe_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Show a toast when the server is unreachable (network error / offline)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      // No response = server down or network issue
      toast.error("Server is currently offline. Please try again later.", {
        id: "server-offline", // prevents duplicate toasts
        duration: 6000,
      });
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
